import httpClient from '%app/js/httpClient';
import { createRequest } from '@paysera/http-client-common';
import { router } from '%app/js/common/services/router';

class HallClient {
    updateHall(hash, data) {
        const request = createRequest(
            'PUT',
            router.generate('paysera_seat_selection.hall.update', { hash }),
            data,
        );
        return httpClient.performBaseRequest(request);
    }

    createHall(data) {
        const request = createRequest(
            'POST',
            router.generate('paysera_seat_selection.hall.create'),
            data,
        );
        return httpClient.performBaseRequest(request);
    }

    getHall(hash) {
        const request = createRequest(
            'GET',
            router.generate('paysera_seat_selection.hall.get', { hash }),
        );
        return httpClient.performBaseRequest(request);
    }

    deleteHall(hash) {
        const request = createRequest(
            'DELETE',
            router.generate('paysera_seat_selection.hall.delete', { hash }),
        );
        return httpClient.performBaseRequest(request);
    }

    copyHall(hash) {
        const request = createRequest(
            'POST',
            router.generate('paysera_seat_selection.hall.copy', { hash }),
        );
        return httpClient.performBaseRequest(request);
    }

    moveToPending(hash) {
        const request = createRequest(
            'POST',
            router.generate('paysera_seat_selection.hall.move_to_pending', { hash }),
        );
        return httpClient.performBaseRequest(request);
    }

    moveToPublic(hash) {
        const request = createRequest(
            'POST',
            router.generate('paysera_seat_selection.hall.move_to_public', { hash }),
        );
        return httpClient.performBaseRequest(request);
    }

    getHallsByFilter(filter) {
        const request = createRequest(
            'GET',
            router.generate('paysera_seat_selection.hall.get_by_filter', filter),
        );
        return httpClient.performBaseRequest(request);
    }

    getHallCount() {
        const request = createRequest(
            'GET',
            router.generate('paysera_seat_selection.hall.count'),
        );

        return httpClient.performBaseRequest(request);
    }

    async getHallByEvent(token) {
        const request = createRequest(
            'GET',
            router.generate('paysera_seat_selection_integration.hall.get_by_event', { token }),
        );

        return httpClient.performBaseRequest(request);
    }
}

export default new HallClient();
